import { restApiCallback } from 'api/typed';
import { TIMEOUT_CONFIG } from 'constants/checkout-api-timeout';

const postDefinition = {
  service: '',
  endpoint: 'gifter/cards/validate',
  verbs: ['post'],
  defaultVersion: 2,
  johnLewisGifting: true,
  timeout: TIMEOUT_CONFIG,
  withCredentials: false,
  disallowHeaders: ['breadcrumb', 'features'],
} as const;

export interface OrderGiftCardsValidatedNonce {
  nonce: string;
  card: {
    maskedCardNumber: string;
    balance: number;
  };
}

export default {
  post: restApiCallback(postDefinition, 'post')<OrderGiftCardsValidatedNonce>,
};
